import { render, staticRenderFns } from "./create-fan-point-support.vue?vue&type=template&id=e8551080&scoped=true"
import script from "./create-fan-point-support.vue?vue&type=script&lang=js"
export * from "./create-fan-point-support.vue?vue&type=script&lang=js"
import style0 from "./create-fan-point-support.vue?vue&type=style&index=0&id=e8551080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8551080",
  null
  
)

export default component.exports